<template>
  <n-simple-modal-body :title="title" :closable="false" @close="close()">
    <main><slot /></main>
    <template #rightFooter>
      <n-button
        v-if="variant === 'confirm'"
        variant="secondary"
        @click="onCancelClick"
        :label="$t('general.cancel')"
        :disabled="confirmLoading"
      />
      <n-button
        @click="$emit('confirm')"
        :label="confirmButtonText || $t('general.ok')"
        :icon="confirmButtonIcon"
        :loading="confirmLoading"
        :disabled="confirmLoading"
      />
    </template>
  </n-simple-modal-body>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NConfirm extends Vue {
  @Prop({ type: String }) title?: string
  @Prop({ type: String }) confirmButtonText?: string
  @Prop({ type: String }) confirmButtonIcon?: string
  @Prop({ type: Boolean, default: false }) confirmLoading!: boolean
  @Prop({ type: String, default: 'confirm', validator: (value: string) => ['confirm', 'alert'].includes(value) })
  variant!: 'confirm' | 'alert'

  onCancelClick() {
    if (this.confirmLoading) {
      return
    }
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$emit('close')
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

main {
  @include notch-text-paragraph-regular-M;

  margin-bottom: $notch-space-10x;
  overflow-wrap: anywhere;
}
</style>
